import "./facilityDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";

interface FacilityDetailsViewComponentProps {
    facilityInformation: any;
    onEditModeOpen: any;
    canEdit: boolean;
}

const FacilityDetailsViewComponent = (props: FacilityDetailsViewComponentProps) => {
    const {facilityInformation, onEditModeOpen, canEdit} = props;
    console.log(facilityInformation, 'the facility information')


    return (
        <div className={'facility-details-view-component details-tab-data-content'}>
            {facilityInformation && <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">Basic Details</div>
                    <div className="">
                        {
                            canEdit &&
                            <ButtonComponent
                                className={"white-space-nowrap"}
                                type="button"
                                color={"primary"}
                                variant={"outlined"}
                                startIcon={<EditIcon/>}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Edit Details
                            </ButtonComponent>
                        }
                    </div>
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2} className="pdd-top-0">
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Facility Name"}> {facilityInformation.name || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Facility Type"}> {facilityInformation.type || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                </div>
                <div className="horizontal-line"/>
                <>
                    <div className="view-and-edit-title">Address Details</div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Address Line 1"}> {facilityInformation?.addressDetails?.addressLine1 || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Address Line 2"}> {facilityInformation?.addressDetails?.addressLine2 || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"State"}> {facilityInformation?.addressDetails?.state || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"ZIP Code"}> {facilityInformation?.addressDetails?.zipcode || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"City"}> {facilityInformation?.addressDetails?.city || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>
                    </div>
                </>
                <>
                    <div className="view-and-edit-title">Insurance Preference</div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Is uploading insurance images mandatory for this facility?"}>
                                    {(facilityInformation?.isInsuranceImageRequired === true
                                        ? "Yes"
                                        : facilityInformation?.isInsuranceImageRequired === false
                                            ? "No"
                                            : "Not Specified")}
                                </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>
                    </div>
                </>

            </>}
        </div>
    );

};

export default FacilityDetailsViewComponent;
